import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const CloseEnclosedSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.4332 22.0703C17.9042 22.0703 22.4375 17.5437 22.4375 12.0703C22.4375 6.5969 17.8955 2.07031 12.4244 2.07031C6.9582 2.07031 2.4375 6.5969 2.4375 12.0703C2.4375 17.5437 6.96691 22.0703 12.4332 22.0703ZM12.4332 20.5976C7.71559 20.5976 3.92312 16.7986 3.92312 12.0703C3.92312 7.34198 7.70688 3.54307 12.4244 3.54307C17.1507 3.54307 20.9567 7.34198 20.9567 12.0703C20.9567 16.7986 17.1594 20.5976 12.4332 20.5976ZM9.0157 16.1986C9.22115 16.1986 9.39353 16.1298 9.52538 15.9844L12.4244 13.0714L15.3322 15.9844C15.4728 16.125 15.6403 16.1986 15.8467 16.1986C16.2371 16.1986 16.5509 15.8886 16.5509 15.4971C16.5509 15.2954 16.4735 15.1365 16.3407 14.9911L13.4299 12.0829L16.3494 9.15737C16.4909 9.01193 16.5596 8.853 16.5596 8.66401C16.5596 8.26861 16.2458 7.96727 15.8554 7.96727C15.6665 7.96727 15.5163 8.02736 15.3583 8.18151L12.4244 11.0992L9.51667 8.19022C9.37611 8.04086 9.22115 7.97599 9.0157 7.97599C8.62918 7.97599 8.31537 8.27732 8.31537 8.66879C8.31537 8.86169 8.38892 9.02936 8.5256 9.16608L11.4325 12.0829L8.5256 14.9998C8.38892 15.1365 8.31537 15.3042 8.31537 15.4971C8.31537 15.8886 8.62918 16.1986 9.0157 16.1986Z"
        fill={color}
      />
    </svg>
  );
};

export { CloseEnclosedSvg };
